module.exports = __webpack_public_path__ + "img/shopping-cart.0fb0fe65.svg";